import 'zone.js/plugins/zone-error';
import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация тестового сервера, он же Staging
 */
class EnvironmentAdminTest extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://unieldata.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://unieldata.compo-soft.ru/documents';
  serverApi =  'https://unieldata.compo-soft.ru/api/v1';
  serverUrl =  'https://unieldata.compo-soft.ru';
  impersonatePortalPath = 'https://uniel.compo-soft.ru/cabinet/dashboard';
  accessRolesCatalog = true;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
}

export const environment = new EnvironmentAdminTest();
